var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F04438"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5C7.8675 4.5 4.5 7.8675 4.5 12C4.5 16.1325 7.8675 19.5 12 19.5C16.1325 19.5 19.5 16.1325 19.5 12C19.5 7.8675 16.1325 4.5 12 4.5ZM14.52 13.725C14.7375 13.9425 14.7375 14.3025 14.52 14.52C14.4075 14.6325 14.265 14.685 14.1225 14.685C13.98 14.685 13.8375 14.6325 13.725 14.52L12 12.795L10.275 14.52C10.1625 14.6325 10.02 14.685 9.8775 14.685C9.735 14.685 9.5925 14.6325 9.48 14.52C9.2625 14.3025 9.2625 13.9425 9.48 13.725L11.205 12L9.48 10.275C9.2625 10.0575 9.2625 9.6975 9.48 9.48C9.6975 9.2625 10.0575 9.2625 10.275 9.48L12 11.205L13.725 9.48C13.9425 9.2625 14.3025 9.2625 14.52 9.48C14.7375 9.6975 14.7375 10.0575 14.52 10.275L12.795 12L14.52 13.725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.1b7a45c4949bf7caeca2825753aea60a.svg";
export { ForwardRef as ReactComponent };